import React, { useContext, useEffect, useState } from "react";
import { Button, Form, Modal, Space } from "antd";
import { UserForm } from "./UserForm";
import { user_initial_state } from "../../../utils/data";
import DataContext from "../../../context/DataContext";

interface Props {
  open: boolean;
  onClose: () => void;
}

export const UserModal = ({ open, onClose }: Props) => {
  const [form] = Form.useForm();
  const { handleEditUser, handleCreateUser, userToEdit } =
    useContext(DataContext);
  const [values, setValues] = useState(user_initial_state);

  useEffect(() => {
    userToEdit && setValues(userToEdit);
    return () => {
      setValues(user_initial_state);
    };
  }, [userToEdit]);

  return (
    <>
      <Modal
        title={userToEdit ? "Edit User" : "Create new User"}
        onCancel={onClose}
        open={open}
        footer={
          <Space className="padding-all">
            <Button onClick={onClose} danger>
              Cancel
            </Button>
            <Button
              type="primary"
              htmlType="submit"
              onClick={() => {
                form
                  .validateFields()
                  .then(() => {
                    userToEdit
                      ? handleEditUser(values)
                      : handleCreateUser(values);
                  })
                  .then(() => {
                    setValues(user_initial_state);
                    onClose();
                  })
                  .catch((errorInfo) => {
                    console.log("errorInfo ...", errorInfo);
                  });
              }}
            >
              Save
            </Button>
          </Space>
        }
      >
        <UserForm
          values={values}
          setValues={setValues}
          form={form}
          edit={!!userToEdit}
        />
      </Modal>
    </>
  );
};
